<template>
  <div class="page-top">
    <div class="page-top-inner-wrap">
      <h1 tabindex="0" class="page-title">LIVE</h1>
      <div class="btn-wrap">
        <button v-if="!isPooqzone" type="button" @click.prevent="goToReserveWatch()" class="btn-reservation">시청예약</button>
        <a href="#" @click.prevent="goToSchedule()" class="btn-schedule">편성표</a>
      </div>
    </div>
  </div>
</template>

<script>
import { ALARM_POPUP_TYPE_LIVE, SHOW_ALARM_POPUP } from '@/common/resources/const'
import cookie from '@/common/utils/cookie'
import { PATH_NAME_SCHEDULE } from '@/common/resources/router.const'

  export default {
    name: 'LiveTitle',
    data () {
      return {
        isPooqzone: cookie.isWavveOn()
      }
    },
    methods: {
      goToReserveWatch () {
        this.$events.$emit(SHOW_ALARM_POPUP, ALARM_POPUP_TYPE_LIVE)
      },
      goToSchedule () {
        this.$router.push({ name: PATH_NAME_SCHEDULE })
      }
    }
  }
</script>
